export enum FormularioTipo {
  // geral = 'Geral',
  agendamento = 'Agendamento - Deve ser preenchido no momento do agendamento',
  // preAtendimento = 'Pré-Atendimento - Deve ser preenchido após o agendamento, antes do horário agendado',
  // atendimento = 'Atendimento - Formulário interno para Registro do Atendimento',
  pesquisaSatisfacao = 'Pesquisa de Satisfação - Disponível para ser preenchida após a finalização do atendimento'
}
